/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Perm_ListingsInputs */

const en_team_perm_listings = /** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

const es_team_perm_listings = /** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuncios`)
};

const fr_team_perm_listings = /** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonces`)
};

const de_team_perm_listings = /** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserate`)
};

const id_team_perm_listings = /** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing`)
};

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const ja_team_perm_listings = en_team_perm_listings;

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const zh_team_perm_listings = en_team_perm_listings;

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const ar_team_perm_listings = en_team_perm_listings;

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const it_team_perm_listings = en_team_perm_listings;

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const ru_team_perm_listings = en_team_perm_listings;

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const pt_team_perm_listings = en_team_perm_listings;

/** @type {(inputs: Team_Perm_ListingsInputs) => LocalizedString} */
const ko_team_perm_listings = en_team_perm_listings;

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Team_Perm_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_perm_listings = /** @type {((inputs?: Team_Perm_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Perm_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_perm_listings(inputs)
	if (locale === "es") return es_team_perm_listings(inputs)
	if (locale === "fr") return fr_team_perm_listings(inputs)
	if (locale === "de") return de_team_perm_listings(inputs)
	if (locale === "ja") return ja_team_perm_listings(inputs)
	if (locale === "zh") return zh_team_perm_listings(inputs)
	if (locale === "ar") return ar_team_perm_listings(inputs)
	if (locale === "id") return id_team_perm_listings(inputs)
	if (locale === "it") return it_team_perm_listings(inputs)
	if (locale === "ru") return ru_team_perm_listings(inputs)
	if (locale === "pt") return pt_team_perm_listings(inputs)
	return ko_team_perm_listings(inputs)
});